import { useAppSelector } from '@store/hooks'
import { selectSelectedMembershipProfileTag } from '@store/membership/MembershipProfileTagReducer'
import {
  ColorPicker,
  IconPicker,
} from '@supplement-bacon/react-toolkit/components'
import { SBRMFormActionProps } from '@supplement-bacon/sbrm-react'
import { requiredRule } from '@utils/rules'
import { Form, Input } from 'antd'
import { useEffect } from 'react'

const Update = ({ form, formProps }: SBRMFormActionProps) => {
  const item = useAppSelector(selectSelectedMembershipProfileTag())

  useEffect(() => {
    form.setFieldsValue(item)
  }, [item])

  if (item === undefined) {
    return <></>
  }

  return (
    <Form {...formProps} form={form} layout="vertical">
      <Form.Item name="id" hidden style={{ display: 'none' }} rules={[]}>
        <Input type="hidden" />
      </Form.Item>
      <Form.Item name="name" rules={[requiredRule()]} label={'Name'}>
        <Input />
      </Form.Item>
      <Form.Item name="icon" label="Icon">
        <IconPicker />
      </Form.Item>
      <Form.Item name="color" label="Color">
        <ColorPicker />
      </Form.Item>
    </Form>
  )
}

export default Update
